import {CONTENT_TYPE_TEXT, DISPLAY_NAME_BOT, ROLE_SYSTEM, TYPE_MESSAGE} from "./constants";

export const transformFirstSystemMessage = (title) => {
    const content = JSON.stringify({
        type: "interactive",
        intent: "StartChatbot",
        title: title,
    });
    return {
        "Content": content,
        "ContentType": CONTENT_TYPE_TEXT,
        "Type": TYPE_MESSAGE,
        "DisplayName": DISPLAY_NAME_BOT,
        "ParticipantRole": ROLE_SYSTEM,
        "startMessage": true,
    };
};

export const transformSecondSystemMessage = (title) => {
    return {
        "Content": title,
        "ContentType": CONTENT_TYPE_TEXT,
        "Type": TYPE_MESSAGE,
        "DisplayName": DISPLAY_NAME_BOT,
        "ParticipantRole": ROLE_SYSTEM
    };
}